import { call, put, select } from 'redux-saga/effects';
import utility from '../util/utility';
import { isCanada } from '../../../../../utils';
import logger from '../../../../../utils/loggerInstance';
import { setServerErrorCheckout } from './Checkout.action.util';
import Selector, { isExpressCheckout } from './Checkout.selector';
import getErrorList from '../../BagPage/container/Errors.selector';
import constants, { CHECKOUT_ROUTES } from '../Checkout.constants';
import BagSelector from '../../BagPage/container/BagPage.selectors';
import { getSetGiftWrapOptionsActn, toggleCheckoutRouting } from './Checkout.action';
import { getServerErrorMessage } from '../../../../../services/abstractors/CnC/Checkout';
import { getGiftOptionsTTL } from '../../../../../reduxStore/selectors/session.selectors';
import { getGiftWrappingOptions } from '../../../../../services/abstractors/CnC/CheckoutSFCC';
import { getGiftWrapOptions } from '../organisms/ShippingPage/molecules/GiftServices/container/GiftServices.selector';

export function* getGiftWrapOptionsData() {
  const giftWrap = yield select(getGiftWrapOptions);
  if (!giftWrap && !isCanada()) {
    try {
      const cacheTTL = yield select(getGiftOptionsTTL);
      const res = yield call(getGiftWrappingOptions, cacheTTL);
      yield put(getSetGiftWrapOptionsActn(res));
    } catch (e) {
      logger.error(e);
    }
  }
}

export function* getRouteToCheckoutStage(_, isExpress, isBagRouting) {
  let isExpressCheckoutEnabled = isExpress;
  if (!isExpress) {
    isExpressCheckoutEnabled = yield select(isExpressCheckout);
  }
  const { PICKUP, SHIPPING, REVIEW } = constants.CHECKOUT_STAGES;
  let requestedStage;
  const itemsCount = yield select(BagSelector.getTotalItems);
  if (isExpressCheckoutEnabled && (!isBagRouting || itemsCount > 0)) {
    requestedStage = REVIEW;
  } else {
    const orderHasPickup = yield select(Selector.getIsOrderHasPickup);
    requestedStage = orderHasPickup ? PICKUP : SHIPPING;
  }
  utility.routeToPage(CHECKOUT_ROUTES.singlePageCheckoutPage);
  yield put(toggleCheckoutRouting(true));
  return requestedStage;
}

export function* handleServerSideErrorAPI(e, componentName, isMinibag) {
  const errorsMapping = yield select(getErrorList);
  const billingError = getServerErrorMessage(e, errorsMapping);
  yield put(
    setServerErrorCheckout({
      errorMessage: billingError,
      component: componentName || constants.PAGE,
      isMinibag,
      errorCode: e?.errorCodes,
    })
  );
}
